// Module Federation runtime plugin. Loaded on both browser and Node compiles.
//
// The remote URL in next.config.mjs is baked into the bundle at build time, and
// CI builds one image for every environment. This plugin swaps in the
// per-environment URL at runtime: FE_COMMON_REMOTE from
// window.__RUNTIME_CONFIG__ in the browser (set in _document.tsx), and
// SERVER_FE_COMMON_REMOTE from process.env on the server.
//
// It replaces fe-legacy-template's own plugin, which set publicPath to the
// origin only. That breaks every chunk of a production (CDN) manifest
// (FAAS-754). The toolkit version handles both production and dev manifests.
import { createRuntimeRemotesPlugin } from '@fe-toolkit/utility/modern/client'

export default createRuntimeRemotesPlugin({
  remotes: {
    fe_common: {
      publicEnvVar: 'FE_COMMON_REMOTE',
      serverEnvVar: 'SERVER_FE_COMMON_REMOTE',
    },
  },
})
